import { create } from 'axios';
import appLS from '../constants/local-storage';
const headers = {
  'Accept': 'application/json',
  'Content-Type': 'application/json',
  'Access-Control-Allow-Origin': '*',
}

const elsa = create({
  baseURL: process.env.REACT_APP_MARKETPLACE_API,
  headers: { ...headers }
});

const framework = create({
  baseURL: process.env.REACT_APP_FRAMEWORK_API,
  headers: { ...headers }
});

const setAccessToken = () => {
  const user = localStorage.getItem(appLS.user);
  const token = user ? JSON.parse(user).access_token : '';
  framework.defaults.headers.common['Authorization'] = `Bearer ${token}`;
}

const setCompanyKey = () => {
  const companyKey = localStorage.getItem(appLS.companyKey);
  framework.defaults.headers.common['CompanyKey'] = companyKey;
}

export default {
  elsa,
  framework,
  setAccessToken,
  setCompanyKey
};